/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSubjects.defs.js'
export * as $defs from './getSubjects.defs.js'
